<template>
  <section>
    <loading-flux :value="loading"></loading-flux>
    <v-dialog
      v-model="modalAction"
      max-width="1200px"
      scrollable
      @keydown="executeCloseModalGenerateHes"
      @click:outside="executeCloseModalGenerateHes"
    >
      <v-card v-if="currentServiceWithHes">
        <div class="p-4 pb-0">
          <h5>
            Generar nueva HES del servicio
            <b>{{ currentServiceWithHes.material.name }}</b>
            con código:
            <b>
              {{
                currentServiceWithHes
                  ? currentServiceWithHes.material.code
                  : "-"
              }}
            </b>
          </h5>
        </div>
        <hr />
        <v-card-text>
          <v-container class="pt-0">
            <v-row>
              <v-col cols="12" md="2" sm="12">
                <label for="amount_pending" class="mt-3">Código SAP</label>
                <p class="font-weight-bold">
                  {{
                    currentServiceWithHes
                      ? currentServiceWithHes.material.code
                      : "-"
                  }}
                </p>
              </v-col>
              <v-col cols="12" md="2" sm="12">
                <label for="amount_pending" class="mt-3">
                  Cantidad
                </label>
                <p class="my-0 mt-1 font-weight-bold" style="font-size: 12px">
                  {{ currentServiceWithHes.quantity }}
                </p>
              </v-col>
              <v-col cols="12" md="2" sm="12">
                <label for="amount_pending" class="mt-3">
                  Precio Neto
                </label>
                <p class="my-0 mt-1 font-weight-bold" style="font-size: 12px">
                  {{
                    currentServiceWithHes.price
                      ? `${new Intl.NumberFormat("de-DE").format(
                          Number(currentServiceWithHes.price)
                        )}`
                      : "Por definir"
                  }}
                  {{
                    currentServiceWithHes.currency
                      ? currentServiceWithHes.currency
                      : "CLP"
                  }}
                </p>
              </v-col>
              <v-col cols="12" md="2" sm="12">
                <label for="amount_pending" class="mt-3">
                  Monto Neto
                </label>
                <p class="my-0 mt-1 font-weight-bold" style="font-size: 12px">
                  {{
                    currentServiceWithHes.total
                      ? `${new Intl.NumberFormat("de-DE").format(
                          Number(currentServiceWithHes.total)
                        )}`
                      : "Por definir"
                  }}
                  {{
                    currentServiceWithHes.currency
                      ? currentServiceWithHes.currency
                      : "CLP"
                  }}
                </p>
              </v-col>
              <v-col cols="12" md="2" sm="12">
                <label for="iva" class="mt-3">
                  IVA
                </label>
                <p class="my-0 mt-1 font-weight-bold" style="font-size: 12px">
                  {{
                    currentServiceWithHes.applied_tax
                      ? `${new Intl.NumberFormat("de-DE").format(
                          Number(currentServiceWithHes.applied_tax)
                        )}`
                      : "-"
                  }}
                  {{
                    !currentServiceWithHes.applied_tax
                      ? ""
                      : currentServiceWithHes.currency
                      ? currentServiceWithHes.currency
                      : "CLP"
                  }}
                </p>
              </v-col>
              <v-col cols="12" md="2" sm="12">
                <label for="amount_total" class="mt-3">
                  Monto Total
                </label>
                <p class="my-0 mt-1 font-weight-bold" style="font-size: 12px">
                  {{
                    currentServiceWithHes.price_with_tax
                      ? `${new Intl.NumberFormat("de-DE").format(
                          Number(currentServiceWithHes.price_with_tax)
                        )}`
                      : "-"
                  }}
                  {{
                    !currentServiceWithHes.price_with_tax
                      ? ""
                      : currentServiceWithHes.currency
                      ? currentServiceWithHes.currency
                      : "CLP"
                  }}
                </p>
              </v-col>
              <v-col cols="12" md="2" sm="12">
                <label for="amount_pending" class="mt-3"
                  >Porcentaje Pendiente</label
                >
                <p
                  class="font-weight-bold"
                  :class="{
                    'text-danger': invalidQuantity,
                    'text-success': !invalidQuantity,
                  }"
                >
                  {{ getPercentageFormCalculatedWithPending.toFixed(2) }}%
                </p>
              </v-col>
            </v-row>
            <br />
            <v-form @submit.prevent="generateNewHes" class="mt-5">
              <v-row align-content="center">
                <v-col
                  cols="12"
                  md="4"
                  sm="12"
                  v-if="!currentServiceWithHes.applied_tax"
                >
                  <label for="percentage_hes">
                    Monto HES ({{
                      currentServiceWithHes.currency
                        ? currentServiceWithHes.currency
                        : "CLP"
                    }})
                  </label>
                  <v-text-field
                    v-if="!currentServiceWithHes.applied_tax"
                    placeholder="Monto HES"
                    :value="amountHesFormatted"
                    @keypress="validateAmount"
                    @paste="validateAmount"
                    @input="calculateAllFields"
                    :error="$v.form.amount_hes.$invalid && submitUpload"
                    :error-messages="
                      $v.form.amount_hes.$invalid && submitUpload
                        ? 'Este campo es requerido'
                        : null
                    "
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                  sm="12"
                  v-if="
                    currentServiceWithHes.applied_tax &&
                      currentServiceWithHes.tax_code === 'IVA'
                  "
                >
                  <label for="percentage_hes">
                    Monto Neto HES ({{
                      currentServiceWithHes.currency
                        ? currentServiceWithHes.currency
                        : "CLP"
                    }})
                  </label>
                  <v-text-field
                    :value="amountHesFormatted"
                    @keypress="validateAmount"
                    @paste="validateAmount"
                    @input="calculateAllFields"
                    placeholder="Monto Neto HES"
                    :error="$v.form.amount_hes.$invalid && submitUpload"
                    :error-messages="
                      $v.form.amount_hes.$invalid && submitUpload
                        ? 'Este campo es requerido'
                        : null
                    "
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" sm="12">
                  <label for="percentage_hes"> Porcentaje HES (%) </label>
                  <v-text-field
                    type="number"
                    disabled
                    :value="
                      form.percentage_hes ? form.percentage_hes.toFixed(2) : 0
                    "
                    @input="calculateQuantity()"
                    placeholder="Porcentaje"
                    :error="$v.form.percentage_hes.$invalid && submitUpload"
                    :error-messages="
                      $v.form.percentage_hes.$invalid && submitUpload
                        ? 'Este campo es requerido'
                        : null
                    "
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" sm="12">
                  <label for="quantity_hes"> Cantidad * </label>
                  <v-text-field
                    disabled
                    type="number"
                    :step="{
                      type: Number,
                      default: 0.01,
                    }"
                    :placeholder="`Ingresa la cantidad`"
                    @input="validateDecimals($event)"
                    v-model="$v.form.quantity_hes.$model"
                    :error="$v.form.quantity_hes.$invalid && submitUpload"
                    :error-messages="
                      $v.form.quantity_hes.$invalid && submitUpload
                        ? 'Este campo es requerido'
                        : null
                    "
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                  sm="12"
                  v-if="
                    currentServiceWithHes.applied_tax &&
                      currentServiceWithHes.tax_code === 'IVA'
                  "
                >
                  <label for="percentage_hes">
                    IVA ({{
                      currentServiceWithHes.currency
                        ? currentServiceWithHes.currency
                        : "CLP"
                    }})
                  </label>
                  <v-text-field
                    disabled
                    placeholder="Monto Neto HES"
                    v-model="form.iva_hes"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                  sm="12"
                  v-if="
                    currentServiceWithHes.applied_tax &&
                      currentServiceWithHes.tax_code === 'IVA'
                  "
                >
                  <label for="percentage_hes">
                    Monto Total HES ({{
                      currentServiceWithHes.currency
                        ? currentServiceWithHes.currency
                        : "CLP"
                    }})
                  </label>
                  <v-text-field
                    disabled
                    placeholder="Monto Total HES"
                    :value="getTotalAmountHes"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  sm="12"
                  v-if="invalidQuantity"
                  class="py-0"
                >
                  <pre>
                    {{ invalidQuantity }}
                  </pre>
                  <h6 class="text-danger text-center">
                    <v-icon large color="red darken-2">
                      mdi-alert-circle-outline
                    </v-icon>
                    <b>
                      ATENCIÓN:
                    </b>
                    El Porcentaje de la HES supera el porcentaje
                    <b> PENDIENTE</b>
                  </h6>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  sm="12"
                  v-if="invalidQuantityForm"
                  class="py-0"
                >
                  <h6 class="text-danger text-center">
                    <v-icon large color="red darken-2">
                      mdi-alert-circle-outline
                    </v-icon>
                    <b>
                      ATENCIÓN:
                    </b>
                    La cantidad ingresada es menor a cero
                  </h6>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            outlined
            @click="executeCloseModalGenerateHes"
          >
            <small> Cerrar </small>
          </v-btn>
          <v-btn
            outlined
            color="blue darken-1"
            @click="calculateQuantityFromPercentagePending"
          >
            <small> Calcular Monto Pendiente </small>
          </v-btn>
          <v-btn
            :disabled="
              loading ||
                !form.amount_hes ||
                !form.quantity_hes ||
                invalidQuantity
            "
            color="blue lighten-1 text-white"
            @click="generateNewHes"
          >
            <small> Generar HES </small>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { authUsuarioComputed } from "@/state/helpers";
import { preventCloseIfNotKeyEventEsc } from "@/helpers/common";
import { required } from "vuelidate/lib/validators";
import swal from "sweetalert2";
import { getAllHes } from "@/constants/supplying/hes";
import {
  DECIMAL_IVA_APLICABLE,
  calculateNetAmountHes,
} from "@/constants/supplying/hes";
export default {
  props: {
    modalAction: {
      type: Boolean,
      default: false,
    },
    closeModalGenerateHes: {
      type: Function,
      default: () => {},
    },
    currentServiceWithHes: {
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      submitUpload: false,
      form: {
        percentage_hes: null,
        amount_hes: null,
        quantity_hes: null,
        iva_hes: null,
      },
    };
  },
  validations: {
    form: {
      amount_hes: {
        required,
      },
      percentage_hes: {
        required,
      },
      quantity_hes: {
        required,
      },
    },
  },
  methods: {
    ...mapActions({
      generateHes: "supplying/generateHes",
    }),
    //METODOS ESPECIFICOS PARA NUEVO CALCULO EN BASE A MONTO AD-1719
    setAmountHes(value) {
      if (this.currentServiceWithHes.currency == "CLP") {
        this.form.amount_hes = value.replaceAll(",", "").replaceAll(".", "");
      } else {
        this.form.amount_hes = value.replaceAll(".", "");
      }
    },
    calculateAllFields(value) {
      this.setAmountHes(value);
      this.calculatePercentage();
      this.calculateQuantity();
      this.calculateIvaAmount();
    },
    validateAmount(event) {
      let textToValidate = event.key
        ? event.key
        : event.clipboardData.getData("text");
      const allowedCharacters =
        this.currentServiceWithHes.currency == "CLP" ? /[0-9]/ : /[0-9.,]/;
      if (this.currentServiceWithHes.currency !== "CLP") {
        if (String(this.form.amount_hes).includes(",")) {
          const [int, dec] = this.form.amount_hes.split(",");
          if (dec.length == 2) {
            event.preventDefault();
          }
        }
      }
      if (!allowedCharacters.test(textToValidate)) {
        event.preventDefault();
      }
    },
    //CIERRE METODOS PARA NUEVO CALCULO EN BASE A MONTO AD-1719
    executeCloseModalGenerateHes($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.resetForm();
        this.closeModalGenerateHes($event);
      }
    },
    validateDecimals(quantity) {
      let value = quantity;
      value = value.replace(/[^0-9.,]/g, "");

      if (value.includes(".")) {
        const [int, dec] = value.split(".");
        value = dec.length > 2 ? `${int}.${dec.slice(0, 2)}` : value;
      }

      if (value.includes(",")) {
        const [int, dec] = value.split(",");
        value = dec.length > 2 ? `${int}.${dec.slice(0, 2)}` : value;
      }
      setTimeout(() => {
        this.form.quantity_hes = value;
        this.calculatePercentage();
        this.calculateAmount();
        this.calculateIvaAmount();
      }, 1);
    },
    calculateAmount() {
      if (
        this.currentServiceWithHes.applied_tax &&
        this.currentServiceWithHes.tax_code === "IVA"
      ) {
        //El monto neto seria
        this.form.amount_hes = new Intl.NumberFormat("es-CL", {
          minimumFractionDigits:
            this.currentServiceWithHes.currency == "CLP" ? 0 : 2,
          maximumFractionDigits:
            this.currentServiceWithHes.currency == "CLP" ? 0 : 2,
        }).format(
          ((this.form.percentage_hes / 100) *
            this.currentServiceWithHes.price_with_tax) /
            (1 + DECIMAL_IVA_APLICABLE)
        );
      } else {
        //Calcular en base a la cantidad ingresada y el monto total del servicio
        this.form.amount_hes = new Intl.NumberFormat("es-CL", {
          minimumFractionDigits:
            this.currentServiceWithHes.currency == "CLP" ? 0 : 2,
          maximumFractionDigits:
            this.currentServiceWithHes.currency == "CLP" ? 0 : 2,
        }).format(
          (this.form.percentage_hes / 100) * this.currentServiceWithHes.total
        );
      }
    },
    calculateIvaAmount() {
      if (
        this.currentServiceWithHes.applied_tax &&
        this.currentServiceWithHes.tax_code === "IVA"
      ) {
        //El monto neto seria
        let amount_hes =
          this.currentServiceWithHes.currency == "CLP"
            ? Number(
                this.form.amount_hes.replaceAll(",", "").replaceAll(".", "")
              )
            : Number(
                this.form.amount_hes.replaceAll(".", "").replaceAll(",", ".")
              );
        this.form.iva_hes = new Intl.NumberFormat("es-CL", {
          minimumFractionDigits:
            this.currentServiceWithHes.currency == "CLP" ? 0 : 2,
          maximumFractionDigits:
            this.currentServiceWithHes.currency == "CLP" ? 0 : 2,
        }).format(amount_hes * DECIMAL_IVA_APLICABLE);
      } else {
        this.form.iva_hes = 0;
      }
    },
    calculateQuantity() {
      this.form.quantity_hes =
        (this.form.percentage_hes * this.currentServiceWithHes.quantity) / 100;
    },
    calculatePercentage() {
      this.form.percentage_hes =
        (Number(this.form.amount_hes.replace(",", ".")) * 100) /
        Number(this.currentServiceWithHes.total);

      this.form.quantity_hes = this.form.quantity_hes;
    },
    calculatePercentageFromQuantity() {
      this.form.percentage_hes =
        (this.form.quantity_hes * 100) / this.currentServiceWithHes.quantity;
    },

    calculateQuantityFromPercentagePending() {
      this.form.quantity_hes = Number(
        (this.getPendingPercentage * this.currentServiceWithHes.quantity) / 100
      );
      this.calculatePercentageFromQuantity();
      this.calculateAmount();
      this.calculateIvaAmount();
    },
    async generateNewHes() {
      let self = this;
      self.loading = true;
      self.submitUpload = true;
      if (!self.$v.form.$invalid && !self.invalidQuantity) {
        const resp = await self.generateHes({
          purchase_order_id: self.currentServiceWithHes.request_id,
          purchase_order_items: {
            [self.currentServiceWithHes.id]: [
              Number(self.form.percentage_hes) / 100,
              self.form.quantity_hes,
            ],
          },
          user: this.user.email,
        });
        if (!resp || resp.status == 500) {
          self.loading = false;
          self.$swal.fire({
            icon: "error",
            title: "Error",
            text:
              "Ha ocurrido un error en el servidor, intenta de nuevo mas tarde",
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 4000,
            timerProgressBar: true,
          });
          return;
        }
        if (resp?.status === 200) {
          swal.fire({
            icon: "success",
            title: "Excelente",
            text: `Se genero la HES del servicio ${this.currentServiceWithHes.material.code} - ${this.currentServiceWithHes.material.name} con éxito`,
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 5000,
            timerProgressBar: true,
          });
          self.resetForm();
          self.$emit("hesGenerated");
          self.closeModalGenerateHes();
        }
        if (resp?.status === 400) {
          swal.fire({
            icon: "error",
            title: "Error",
            text: resp?.data?.detail?.message
              ? resp.data.detail.message.value
              : resp.data.detail,
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 5000,
            timerProgressBar: true,
          });
        }
        self.loading = false;
      }
    },
    resetForm() {
      this.form.percentage_hes = null;
      this.form.quantity_hes = null;
      this.form.amount_hes = null;
      this.form.iva_hes = null;
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({}),
    amountHesFormatted() {
      if (!this.form.amount_hes || !/\d/.test(this.form.amount_hes))
        return null;
      //Si la moneda es CLP, regresar el numero con separador de miles de puntos sin decimales
      if (this.currentServiceWithHes.currency == "CLP") {
        return new Intl.NumberFormat("es-CL", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(
          parseFloat(this.form.amount_hes.replace(/\./g, "").replace(",", "."))
        );
      }
      //Si la moneda es UF, regresar el numero con decimales usando la coma y separador de miles de puntos
      return new Intl.NumberFormat("es-CL", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(
        parseFloat(this.form.amount_hes.replace(/\./g, "").replace(",", "."))
      );
    },
    invalidQuantityForm() {
      return this.form.quantity_hes < 0;
    },
    invalidQuantity() {
      let amount_hes =
        this.form.amount_hes && this.currentServiceWithHes.currency == "CLP"
          ? Number(this.form.amount_hes.replaceAll(",", "").replaceAll(".", ""))
          : this.form.amount_hes
          ? Number(
              this.form.amount_hes.replaceAll(".", "").replaceAll(",", ".")
            )
          : null;
      return (
        amount_hes > this.currentServiceWithHes.total ||
        amount_hes > this.calculateAmountPendingAllHes
      );
    },
    getPendingPercentage() {
      if (
        this.currentServiceWithHes &&
        getAllHes(this.currentServiceWithHes).length
      ) {
        // 1. Sum the quantity of all existing HES to get the total completed quantity.
        const quantityCompleted = getAllHes(this.currentServiceWithHes).reduce(
          (total, hes) => {
            return total + hes.quantity;
          },
          0
        );

        // 2. Calculate what percentage of the total service quantity has been completed.
        const percentageCompleted =
          (quantityCompleted * 100) / this.currentServiceWithHes.quantity;

        // 3. The pending percentage is 100 minus the completed percentage.
        return 100 - percentageCompleted;
      }
      // If there are no existing HES, 100% is pending.
      return 100;
    },
    calculateAmountPendingAllHes() {
      let amountTotalNetListHes = getAllHes(this.currentServiceWithHes).reduce(
        (total, hes) => {
          let amountNet = Number(
            calculateNetAmountHes(hes, this.currentServiceWithHes)
          );
          return total + amountNet;
        },
        0
      );
      return (this.currentServiceWithHes.total - amountTotalNetListHes).toFixed(
        this.currentServiceWithHes.currency == "CLP" ? 0 : 2
      );
    },
    getPercentageFormCalculatedWithPending() {
      let currentPercentage = this.form.percentage_hes
        ? this.form.percentage_hes
        : 0;
      return this.getPendingPercentage - currentPercentage;
    },

    getTotalAmountHes() {
      if (this.form.amount_hes && this.form.iva_hes) {
        return new Intl.NumberFormat("es-CL", {
          minimumFractionDigits:
            this.currentServiceWithHes.currency == "CLP" ? 0 : 2,
          maximumFractionDigits:
            this.currentServiceWithHes.currency == "CLP" ? 0 : 2,
        }).format(
          parseFloat(
            this.form.amount_hes.replace(/\./g, "").replace(",", ".")
          ) + parseFloat(this.form.iva_hes.replace(/\./g, "").replace(",", "."))
        );
      } else {
        0;
      }
    },
  },
};
</script>

<style></style>
